import { Select } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import axios from 'axios'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useVideosInsert } from '../../api/hooks/Videos/useVideosInsert'
import ResultContent from '../../components/admin/ResultContent'
import BaseInput from '../../components/common/BaseInput'
import Label from '../../components/common/Label'
import SaveButton from '../../components/common/SaveButton'
import SaveResultModal from '../../components/common/SaveResultModal'
import styles from '../../styles/admin/StudyContent.module.scss'
import { notifications } from '@mantine/notifications'

const LectureCreateContent = ({ questionId, fromPage,level }) => {
  const navigate = useNavigate()
  const [opened, { open, close }] = useDisclosure(false)
  const [saveStatus, setSaveStatus] = useState(null)
  const [videoLabelInput, setVideoLabelInput] = useState('')
  const [autoSetQueue, setAutoSetQueue] = useState({})
  const [currentAutoStep, setCurrentAutoStep] = useState('none')

  console.log("비디오 페이지 : " , fromPage)
  console.log("비디오 레벨 : ", level)

  const baseUrl = process.env.REACT_APP_API_URL

  const { insertVideo, isPending } = useVideosInsert()

  const [levelOptions, setLevelOptions] = useState([])
  const [mainOptions, setMainOptions] = useState([])
  const [subOptions, setSubOptions] = useState([])
  const [unitOptions, setUnitOptions] = useState([])
  const [detailUnitOptions, setDetailUnitOptions] = useState([])

  const [chapterMeta, setChapterMeta] = useState({
    depth2: '',
    depth3: '',
    depth4: '',
    depth5: '',
  })

  const [formData, setFormData] = useState({
    level: '',
    mainChapter: '',
    subChapter: '',
    unit: '',
    detailUnit: '',
    count: '',
    selectedType: '',
    title: '',
    vimeoId: '',
    hashKey: '',
  })

  const createUniqueOptions = useCallback((data, valueKey, depthKey) => {
    if (!Array.isArray(data)) return []

    return data
      .filter(
        (item) =>
          item[valueKey] !== null &&
          item[valueKey] !== undefined &&
          item[valueKey] !== ''
      )
      .map((item) => ({
        value: item[valueKey],
        label: item[valueKey],
        depth: item[depthKey]?.toString() || '',
      }))
      .filter(
        (option, index, array) =>
          array.findIndex((item) => item.value === option.value) === index
      )
  }, [])

  const generateQuestionLabel = useCallback(() => {
    const level = formData.level.replace(/level\s*/i, '').trim()
    const { depth2, depth3, depth4, depth5 } = chapterMeta

    if (!level || !depth2 || !depth3 || !depth4 || !depth5) return ''
    return `${level}-${depth2}-${depth3}-${depth4}-${depth5}`
  }, [formData.level, chapterMeta])

  const questionLabel = useMemo(() => {
    return generateQuestionLabel()
  }, [generateQuestionLabel])

  const handleMainChapterChange = useCallback(
    (value, option) => {
      const mainValue = value || ''
      const depth = option?.depth || ''

      setFormData((prev) => ({ ...prev, mainChapter: mainValue }))
      setChapterMeta((prev) => ({ ...prev, depth2: depth }))

      if (mainValue) {
        fetchSubOptions(formData.level, mainValue)
      }

      setSubOptions([])
      setUnitOptions([])
      setDetailUnitOptions([])
      setFormData((prev) => ({
        ...prev,
        subChapter: '',
        unit: '',
        detailUnit: '',
      }))
      setChapterMeta((prev) => ({
        ...prev,
        depth3: '',
        depth4: '',
        depth5: '',
      }))
    },
    [formData.level]
  )

  const handleSubChapterChange = useCallback(
    (value, option) => {
      const subValue = value || ''
      const depth = option?.depth || ''

      setFormData((prev) => ({ ...prev, subChapter: subValue }))
      setChapterMeta((prev) => ({ ...prev, depth3: depth }))

      if (subValue) {
        fetchUnitOptions(formData.level, formData.mainChapter, subValue)
      }

      setUnitOptions([])
      setDetailUnitOptions([])
      setFormData((prev) => ({
        ...prev,
        unit: '',
        detailUnit: '',
      }))
      setChapterMeta((prev) => ({
        ...prev,
        depth4: '',
        depth5: '',
      }))
    },
    [formData.level, formData.mainChapter]
  )

  const handleUnitChange = useCallback(
    (value, option) => {
      const nextUnit = value || ''
      const depth = option?.depth || ''
      const { level, mainChapter, subChapter } = formData

      setFormData((prev) => ({ ...prev, unit: nextUnit, detailUnit: '' }))
      setChapterMeta((prev) => ({ ...prev, depth4: depth, depth5: '' }))

      if (level && mainChapter && subChapter && nextUnit) {
        fetchDetailUnitOptions(level, mainChapter, subChapter, nextUnit)
      }

      setDetailUnitOptions([])
    },
    [formData]
  )

  const handleDetailUnitChange = useCallback((value, option) => {
    const nextDetail = value || ''
    const depth = option?.depth || ''

    setFormData((prev) => ({ ...prev, detailUnit: nextDetail }))
    setChapterMeta((prev) => ({ ...prev, depth5: depth }))
  }, [])

  const findOption = useCallback((options, searchValue) => {
    if (!options || options.length === 0) return null
    const firstItem = options[0]
    if (typeof firstItem === 'object' && firstItem !== null) {
      let found = options.find((opt) => opt.value === searchValue || opt.label === searchValue)
      if (found) return found
      found = options.find((opt) => opt.depth === searchValue)
      if (found) return found
      found = options.find((opt) => {
        const labelNumbers = opt.label ? opt.label.toString().match(/\d+/g) : []
        const valueNumbers = opt.value ? opt.value.toString().match(/\d+/g) : []
        return (
          (labelNumbers && labelNumbers.includes(searchValue)) ||
          (valueNumbers && valueNumbers.includes(searchValue))
        )
      })
      return found || null
    }
    if (typeof firstItem === 'string') {
      const match =
        options.find((opt) => opt === searchValue) ||
        options.find((opt) => opt.endsWith(` ${searchValue}`) || opt.endsWith(`${searchValue}`))
      return match ? { value: match, label: match, depth: '' } : null
    }
    return null
  }, [])

  const parseVideoLabel = useCallback((input) => {
    const numbers = input.replace(/[^0-9]/g, '')
    let level, main, sub, unit, detailUnit

    if (numbers.length === 5) {
      ;[level, main, sub, unit, detailUnit] = numbers.split('')
    } else if (numbers.length === 6) {
      level = numbers.substring(0, 2)
      main = numbers.charAt(2)
      sub = numbers.charAt(3)
      unit = numbers.charAt(4)
      detailUnit = numbers.charAt(5)
    } else {
      return
    }

    setAutoSetQueue({ level, main, sub, unit, detailUnit })
    setCurrentAutoStep('level')
  }, [])

  const handleVideoLabelKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        parseVideoLabel(videoLabelInput)
      }
    },
    [parseVideoLabel, videoLabelInput]
  )

  const handleCountChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, count: value }))
  }, [])

  const handleTypeChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, selectedType: value || '' }))
  }, [])

  const handleTitleChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, title: value }))
  }, [])

  const handleVimeoIdChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, vimeoId: value }))
  }, [])

  const handleHashKeyChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, hashKey: value }))
  }, [])

  const handleSaveWithModal = useCallback(async () => {
    if (!formData.level) {
      notifications.show({
        message: 'Please select a Level.',
        color: 'red',
      })
      return
    }
    if (!formData.mainChapter) {
      notifications.show({
        message: 'Please select a Main Chapter.',
        color: 'red',
      })
      return
    }
    if (!formData.subChapter) {
      notifications.show({
        message: 'Please select a Sub Chapter.',
        color: 'red',
      })
      return
    }
    if (!formData.unit) {
      notifications.show({
        message: 'Please select a Unit.',
        color: 'red',
      })
      return
    }
    if (!formData.detailUnit) {
      notifications.show({
        message: 'Please select a Detail Unit.',
        color: 'red',
      })
      return
    }
    if (!formData.title.trim()) {
      notifications.show({
        message: 'Please enter a video title.',
        color: 'red',
      })
      return
    }
    if (!formData.vimeoId.trim()) {
      notifications.show({
        message: 'Please enter a Vimeo ID.',
        color: 'red',
      })
      return
    }
    if (!formData.hashKey.trim()) {
      notifications.show({
        message: 'Please enter a Hash Key.',
        color: 'red',
      })
      return
    }

    try {
      const requestData = {
        LEVEL: parseInt(formData.level.replace('level ', '')) || 1,
        MAIN: parseInt(chapterMeta.depth2) || 1,
        SUB: parseInt(chapterMeta.depth3) || 1,
        UNIT: parseInt(chapterMeta.depth4) || 1,
        DETAIL_UNIT: parseInt(chapterMeta.depth5) || 1,
        TITLE: formData.title,
        VIMEO_ID: formData.vimeoId,
        HASHKEY: formData.hashKey,
      }
      await insertVideo(requestData)
      setSaveStatus({ type: 'success', message: '성공적으로 저장되었습니다.' })
      open()

      setTimeout(() => {
        navigate('/lectures', { state: { fromPage, level } })
      }, 2000)
    } catch (error) {
      const errorMessage = error?.response?.data?.message
      setSaveStatus({ type: 'error', message: errorMessage })
      open()
    }
  }, [formData, chapterMeta, insertVideo, open, navigate])

  const handleModalClose = useCallback(() => {
    close()
    setSaveStatus(null)
  }, [close])

  const handleModalConfirm = useCallback(() => {
    if (saveStatus?.type === 'success') {
      navigate('/lectures', { state: { fromPage, level } })
    } else {
      handleModalClose()
    }
  }, [saveStatus, navigate, handleModalClose])

  const fetchLevelOptions = async () => {
    try {
      const res = await axios.post(`${baseUrl}/chapters/list/levels`)
      const levels = res.data.data
        .filter((item) => item.LEVEL !== null && item.LEVEL !== undefined)
        .map((item) => `level ${item.LEVEL}`)
        .filter((level, index, array) => array.indexOf(level) === index)
      setLevelOptions(levels)
    } catch (error) {
      console.error('Level options fetch error:', error)
      setLevelOptions([])
    }
  }

  const fetchMainOptions = async (level) => {
    try {
      const numericLevel = level.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/mains`, {
        LEVEL: numericLevel,
      })
      const uniqueOptions = createUniqueOptions(res.data.data, 'MAIN', 'DEPTH2')
      setMainOptions(uniqueOptions)
    } catch (error) {
      console.error('Main options fetch error:', error)
      setMainOptions([])
    }
  }

  const fetchSubOptions = async (LEVEL, MAIN) => {
    try {
      const numericLevel = LEVEL.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/subs`, {
        LEVEL: numericLevel,
        MAIN: MAIN,
      })
      const uniqueOptions = createUniqueOptions(res.data.data, 'SUB', 'DEPTH3')
      setSubOptions(uniqueOptions)
    } catch (error) {
      console.error('Sub options fetch error:', error)
      setSubOptions([])
    }
  }

  const fetchUnitOptions = async (LEVEL, MAIN, SUB) => {
    try {
      const numericLevel = LEVEL.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/units`, {
        LEVEL: numericLevel,
        MAIN: MAIN,
        SUB: SUB,
      })
      const uniqueOptions = createUniqueOptions(res.data.data, 'UNIT', 'DEPTH4')
      setUnitOptions(uniqueOptions)
    } catch (error) {
      console.error('Unit options fetch error:', error)
      setUnitOptions([])
    }
  }

  const fetchDetailUnitOptions = async (LEVEL, MAIN, SUB, UNIT) => {
    try {
      const numericLevel = LEVEL.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/detail_units`, {
        LEVEL: numericLevel,
        MAIN: MAIN,
        SUB: SUB,
        UNIT: UNIT,
      })
      const uniqueOptions = createUniqueOptions(
        res.data.data,
        'DETAIL_UNIT',
        'DEPTH5'
      )
      setDetailUnitOptions(uniqueOptions)
    } catch (error) {
      console.error('Detail unit options fetch error:', error)
      setDetailUnitOptions([])
    }
  }

  useEffect(() => {
    fetchLevelOptions()
  }, [])

  const handleLevelChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      level: value || '',
      mainChapter: '',
      subChapter: '',
      unit: '',
      detailUnit: '',
    }))
    setChapterMeta({
      depth2: '',
      depth3: '',
      depth4: '',
      depth5: '',
    })

    if (typeof value === 'string') {
      fetchMainOptions(value)
    }

    setMainOptions([])
    setSubOptions([])
    setUnitOptions([])
    setDetailUnitOptions([])
  }

  useEffect(() => {
    if (currentAutoStep === 'none' || Object.keys(autoSetQueue).length === 0) return

    switch (currentAutoStep) {
      case 'level': {
        if (autoSetQueue.level) {
          const opt = findOption(levelOptions, autoSetQueue.level)
          if (opt) {
            handleLevelChange(opt.value)
            setCurrentAutoStep('main')
          }
        }
        break
      }
      case 'main': {
        if (autoSetQueue.main && mainOptions.length > 0) {
          const opt = findOption(mainOptions, autoSetQueue.main)
          if (opt) {
            handleMainChapterChange(opt.value, opt)
            setCurrentAutoStep('sub')
          } else {
            setCurrentAutoStep('none')
            setAutoSetQueue({})
          }
        }
        break
      }
      case 'sub': {
        if (autoSetQueue.sub && subOptions.length > 0) {
          const opt = findOption(subOptions, autoSetQueue.sub)
          if (opt) {
            handleSubChapterChange(opt.value, opt)
            setCurrentAutoStep('unit')
          } else {
            setCurrentAutoStep('none')
            setAutoSetQueue({})
          }
        }
        break
      }
      case 'unit': {
        if (autoSetQueue.unit && unitOptions.length > 0) {
          const opt = findOption(unitOptions, autoSetQueue.unit)
          if (opt) {
            handleUnitChange(opt.value, opt)
            setCurrentAutoStep('detailUnit')
          } else {
            setCurrentAutoStep('none')
            setAutoSetQueue({})
          }
        }
        break
      }
      case 'detailUnit': {
        if (autoSetQueue.detailUnit && detailUnitOptions.length > 0) {
          const opt = findOption(detailUnitOptions, autoSetQueue.detailUnit)
          if (opt) {
            handleDetailUnitChange(opt.value, opt)
          }
          setCurrentAutoStep('none')
          setAutoSetQueue({})
        }
        break
      }
      default:
        break
    }
  }, [
    currentAutoStep,
    autoSetQueue,
    levelOptions,
    mainOptions,
    subOptions,
    unitOptions,
    detailUnitOptions,
    findOption,
    handleLevelChange,
    handleMainChapterChange,
    handleSubChapterChange,
    handleUnitChange,
    handleDetailUnitChange,
  ])

  const curriculumData = useMemo(
    () => [
      {
        level: (
          <Select
            placeholder="Level"
            data={levelOptions}
            value={formData.level}
            onChange={handleLevelChange}
            disabled={isPending}
            clearable
          />
        ),
        mainChapter: (
          <Select
            placeholder="Choose Main"
            data={mainOptions}
            value={formData.mainChapter}
            onChange={handleMainChapterChange}
            disabled={isPending || !formData.level}
            clearable
          />
        ),
        subChapter: (
          <Select
            placeholder="Choose Sub"
            data={subOptions}
            value={formData.subChapter}
            onChange={handleSubChapterChange}
            disabled={isPending || !formData.mainChapter}
            clearable
          />
        ),
        unit: (
          <Select
            placeholder="Choose Unit"
            data={unitOptions}
            value={formData.unit}
            onChange={handleUnitChange}
            disabled={isPending || !formData.subChapter}
            clearable
          />
        ),
        detailUnit: (
          <Select
            placeholder="Choose Detail Unit"
            data={detailUnitOptions}
            value={formData.detailUnit}
            onChange={handleDetailUnitChange}
            disabled={isPending || !formData.unit}
            clearable
          />
        ),
        count: (
          <BaseInput
            value={formData.count}
            placeholder="0"
            onChange={(e) => handleCountChange(e.target.value)}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={3}
            disabled={isPending}
          />
        ),
        contentType: <Label text="VIDEO" />,
        questionLabel: (
          <input
            value={videoLabelInput}
            placeholder={questionLabel || '51111'}
            onChange={(e) => setVideoLabelInput(e.target.value)}
            onKeyDown={handleVideoLabelKeyDown}
            type="text"
            disabled={isPending}
            style={{
              height: '36px',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              width: '80px',
              padding: '0 8px',
              fontSize: '14px',
            }}
          />
        ),
        type: (
          <Select
            placeholder="Choose Type"
            data={['A', 'B', 'C', 'D', 'E', 'F', 'G']}
            value={formData.selectedType}
            onChange={handleTypeChange}
            disabled={isPending}
            clearable
          />
        ),
      },
    ],
    [
      formData,
      levelOptions,
      mainOptions,
      subOptions,
      unitOptions,
      detailUnitOptions,
      questionLabel,
      videoLabelInput,
      isPending,
      handleMainChapterChange,
      handleSubChapterChange,
      handleUnitChange,
      handleDetailUnitChange,
      handleCountChange,
      handleTypeChange,
      handleVideoLabelKeyDown,
    ]
  )

  const videoData = useMemo(
    () => [
      {
        videoTitle: (
          <BaseInput
            value={formData.title}
            placeholder="Video Title"
            onChange={(e) => handleTitleChange(e.target.value)}
            disabled={isPending}
            className={styles.videoTitleInput}
          />
        ),
        videoID: (
          <BaseInput
            value={formData.vimeoId}
            placeholder="Vimeo ID"
            onChange={(e) => handleVimeoIdChange(e.target.value)}
            disabled={isPending}
            className={styles.videoTitleInput}
          />
        ),
        hash: (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <BaseInput
              value={formData.hashKey}
              placeholder="Hash Key"
              onChange={(e) => handleHashKeyChange(e.target.value)}
              disabled={isPending}
              className={styles.videoTitleInput}
            />
          </div>
        ),
        vimeoId: formData.vimeoId,
        hashKey: formData.hashKey,
        title: formData.title,
      },
    ],
    [
      formData,
      isPending,
      handleTitleChange,
      handleVimeoIdChange,
      handleHashKeyChange,
    ]
  )

  const saveButton = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '20px',
      }}
    >
      <SaveButton onClick={handleSaveWithModal} disabled={isPending}>
        {isPending ? 'Saving...' : 'Save'}
      </SaveButton>
    </div>
  )

  return (
    <>
      <ResultContent
        curriculum={curriculumData}
        videoData={videoData}
        showPreview={true}
        saveButton={saveButton}
      />

      <SaveResultModal
        opened={opened}
        onClose={handleModalClose}
        status={saveStatus}
        onConfirm={handleModalConfirm}
      />
    </>
  )
}

export default LectureCreateContent
